import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, FormControl, InputLabel, Select, MenuItem, Link } from '@mui/material';
import i18n from '../../../i18next';
import { useTranslation } from 'react-i18next';
import ChangePasswordModal from './ChangePasswordModal'; // Asegúrate de ajustar la ruta según sea necesario

const SettingsCard = () => {
    const { t } = useTranslation();
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'es');
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    const handleLanguageChange = (event) => {
        const newLanguage = event.target.value;
        i18n.changeLanguage(newLanguage);
        localStorage.setItem('language', newLanguage); // Guarda el idioma seleccionado en localStorage
        setLanguage(newLanguage);
    };

    const handleOpenPasswordModal = () => {
        setPasswordModalOpen(true);
    };

    const handleClosePasswordModal = () => {
        setPasswordModalOpen(false);
    };

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="div">
                        <span className="roboto-light">{t('settings')}</span>
                    </Typography>
                    <FormControl fullWidth margin="normal" style={{ marginTop: '20px' }}>
                        <FormControl fullWidth>
                            <InputLabel id="language-select-label">{t('language')}</InputLabel>
                            <Select
                                labelId="language-select-label"
                                id="language-select"
                                value={language}
                                label={t('language')}
                                onChange={handleLanguageChange}
                            >
                                <MenuItem value="es">{t('spanish')}</MenuItem>
                                <MenuItem value="en">{t('english')}</MenuItem>
                            </Select>
                        </FormControl>
                    </FormControl>
                    <Typography component="div" style={{ paddingTop: '12px' }}>
                        <Link
                            href="#"
                            color="inherit"
                            underline="hover"
                            onClick={(e) => {
                                e.preventDefault(); // ⛔ prevenir redirección
                                handleOpenPasswordModal(); // ✅ abrir modal
                            }}
                        >
                            <span className="roboto-light">{t('change_password')}</span>
                        </Link>
                    </Typography>
                </CardContent>
            </Card>
            <ChangePasswordModal open={passwordModalOpen} onClose={handleClosePasswordModal} />
        </>
    );
};

export default SettingsCard;
